module.exports = __webpack_public_path__ + "static/media/bg_footer_mobile.e860f4c2.jpg";